module.exports = __webpack_public_path__ + "img/datehookc.3954b21.png";